import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@chakra-ui/react'

const RegisterWidgetDescription = ({ data, theme }) => {
  return (
    <Text
      color={theme.textColor}
      fontFamily='body'
      fontSize={`${theme.descriptionFontSize}em` || 'body'}
      fontWeight={theme.descriptionFontWeight || 'body'}
      lineHeight='tall'
      wordBreak='break-word'
    >
      {data.description}
    </Text>
  )
}

RegisterWidgetDescription.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object
}

export default RegisterWidgetDescription
